/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable operator-linebreak */
import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Typography,
  Box,
  LinearProgress,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api, { authHeader } from '../../../../../../../services/API/apiConfig';
import {
  IconStyled,
  TableCellHeaderStyled,
  TableCellBodyStyled,
  FooterCellStyled,
  CustomCheckbox,
  FirstLayerRow,
  SecondLayerRow,
  LoadingProgressStyled,
} from './index.styles';

export function BudgetTable() {
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(true);

  const { id: constructionId } = useParams();

  const getTotalPrice = () => {
    const total = items.reduce((acc, curr) => acc + curr.price, 0);
    return total.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };

  useEffect(() => {
    api
      .get(`/constructions/${constructionId}/budgets`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        if (data) {
          setItems(data.items_attributes);
          setLoading(false);
        }
      });
  }, []);

  if (loading) {
    return (
      <LoadingProgressStyled>
        <Typography variant="h2" style={{ fontSize: 32 }}>
          Carregando...
        </Typography>
        <LinearProgress style={{ width: '80%' }} />
      </LoadingProgressStyled>
    );
  }

  return (
    <>
      {items && items.length > 0 ? (
        <TableContainer id="budgets-table" component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCellHeaderStyled>Item</TableCellHeaderStyled>
                <TableCellHeaderStyled>Descrição</TableCellHeaderStyled>
                <TableCellHeaderStyled>Und.</TableCellHeaderStyled>
                <TableCellHeaderStyled>Qtd.</TableCellHeaderStyled>
                <TableCellHeaderStyled>
                  Valor unitário (R$)
                </TableCellHeaderStyled>
                <TableCellHeaderStyled>Total orçado</TableCellHeaderStyled>
                <TableCellHeaderStyled>Peso orçado (%)</TableCellHeaderStyled>
                <TableCellHeaderStyled>Total executado</TableCellHeaderStyled>
                <TableCellHeaderStyled>
                  Peso executado (%)
                </TableCellHeaderStyled>
                <TableCellHeaderStyled>Finalizado</TableCellHeaderStyled>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.length &&
                items.map((item) => (
                  <>
                    <FirstLayerRow>
                      <TableCellBodyStyled>{item.item_num}</TableCellBodyStyled>
                      <TableCellBodyStyled>
                        {item.description}
                      </TableCellBodyStyled>
                      <TableCellBodyStyled>
                        {item.items_attributes.length === 0 && item.unit}
                      </TableCellBodyStyled>
                      <TableCellBodyStyled>
                        {item.items_attributes.length === 0 && item.quantity}
                      </TableCellBodyStyled>
                      <TableCellBodyStyled>
                        {item.items_attributes.length === 0 &&
                          item.unit_price.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          })}
                      </TableCellBodyStyled>
                      <TableCellBodyStyled>
                        {item.price.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </TableCellBodyStyled>
                      <TableCellBodyStyled>
                        {item.price_percentage.toFixed(2)} %
                      </TableCellBodyStyled>
                      <TableCellBodyStyled>
                        {item.total_paid.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </TableCellBodyStyled>
                      <TableCellBodyStyled>
                        {item.paid_percentage.toFixed(2)} %
                      </TableCellBodyStyled>
                      <TableCellBodyStyled align="center">
                        {item.items_attributes.length === 0 && (
                          <CustomCheckbox
                            sx={{ padding: 0 }}
                            disabled
                            color="default"
                            checked={item.is_finalized}
                          />
                        )}
                      </TableCellBodyStyled>
                    </FirstLayerRow>

                    {item.items_attributes.map((subItem) => (
                      <>
                        <SecondLayerRow>
                          <TableCellBodyStyled>
                            {item.item_num}.{subItem.item_num}
                          </TableCellBodyStyled>
                          <TableCellBodyStyled>
                            {subItem.description}
                          </TableCellBodyStyled>
                          <TableCellBodyStyled>
                            {subItem.items_attributes.length === 0 &&
                              subItem.unit}
                          </TableCellBodyStyled>
                          <TableCellBodyStyled>
                            {subItem.items_attributes.length === 0 &&
                              subItem.quantity}
                          </TableCellBodyStyled>
                          <TableCellBodyStyled>
                            {subItem.items_attributes.length === 0 &&
                              subItem.unit_price.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                          </TableCellBodyStyled>
                          <TableCellBodyStyled>
                            {subItem.price.toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </TableCellBodyStyled>
                          <TableCellBodyStyled>
                            {subItem.price_percentage.toFixed(2)} %
                          </TableCellBodyStyled>
                          <TableCellBodyStyled>
                            {subItem.total_paid.toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </TableCellBodyStyled>
                          <TableCellBodyStyled>
                            {subItem.paid_percentage.toFixed(2)} %
                          </TableCellBodyStyled>
                          <TableCellBodyStyled align="center">
                            {subItem.items_attributes.length === 0 && (
                              <CustomCheckbox
                                disabled
                                color="deafult"
                                checked={subItem.is_finalized}
                              />
                            )}
                          </TableCellBodyStyled>
                        </SecondLayerRow>

                        {subItem.items_attributes.map((tertiaryItem) => (
                          <TableRow>
                            <TableCellBodyStyled>
                              {item.item_num}.{subItem.item_num}.
                              {tertiaryItem.item_num}
                            </TableCellBodyStyled>
                            <TableCellBodyStyled>
                              {tertiaryItem.description}
                            </TableCellBodyStyled>
                            <TableCellBodyStyled>
                              {tertiaryItem.unit}
                            </TableCellBodyStyled>
                            <TableCellBodyStyled>
                              {tertiaryItem.quantity}
                            </TableCellBodyStyled>
                            <TableCellBodyStyled>
                              {tertiaryItem.unit_price.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                            </TableCellBodyStyled>
                            <TableCellBodyStyled>
                              {tertiaryItem.price.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                            </TableCellBodyStyled>
                            <TableCellBodyStyled>
                              {tertiaryItem.price_percentage.toFixed(2)} %
                            </TableCellBodyStyled>
                            <TableCellBodyStyled>
                              {tertiaryItem.total_paid.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                            </TableCellBodyStyled>
                            <TableCellBodyStyled>
                              {tertiaryItem.paid_percentage.toFixed(2)} %
                            </TableCellBodyStyled>
                            <TableCellBodyStyled align="center">
                              <CustomCheckbox
                                disabled
                                color="deafult"
                                checked={tertiaryItem.is_finalized}
                              />
                            </TableCellBodyStyled>
                          </TableRow>
                        ))}
                      </>
                    ))}
                  </>
                ))}
            </TableBody>
            <TableFooter>
              <TableRow sx={{ border: '1px solid #B0B0B0' }}>
                <FooterCellStyled colSpan={9}>Valor Total</FooterCellStyled>
                <FooterCellStyled>{getTotalPrice()}</FooterCellStyled>
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      ) : (
        <Box
          sx={{
            backgroundColor: '#f6f6f6',
            border: '1px solid #8D8D8D',
            width: '80%',
            textAlign: 'center',
            borderRadius: '8px',
          }}
        >
          <IconStyled />
          <Typography>
            Nenhum orçamento foi adicionado até o momento.
          </Typography>
        </Box>
      )}
    </>
  );
}
